import { render, staticRenderFns } from "./ApiOrderView.vue?vue&type=template&id=427a702c"
import script from "./ApiOrderView.vue?vue&type=script&lang=js"
export * from "./ApiOrderView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports